"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getAdjustmentDetails = getAdjustmentDetails;
exports.getBudgetBillingPlan = getBudgetBillingPlan;
exports.getCurrentBudgetBillingPlan = getCurrentBudgetBillingPlan;
exports.saveNewBudgetBillingPlan = void 0;
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
function getCurrentBudgetBillingPlan(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/budgetbillingplans"));
}
function getBudgetBillingPlan(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/budgetbillingplans"));
}
function getAdjustmentDetails(contractAccountId, billingPlanItemId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/budgetbillingplans/").concat(billingPlanItemId));
}
var saveNewBudgetBillingPlan = exports.saveNewBudgetBillingPlan = function saveNewBudgetBillingPlan(contractAccountId, billingPlanItemId, data) {
  return _RestHelper.default.patch("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/partner/v0/contractaccounts/").concat(contractAccountId, "/budgetbillingplans/").concat(billingPlanItemId), data).then(function (response) {
    _CacheHandler.default.saveCache({
      bbpSaveStatus: response.status
    });
    return response.data;
  }).catch(function (error) {
    throw error.response;
  });
};
var _default = exports.default = {
  getCurrentBudgetBillingPlan: getCurrentBudgetBillingPlan
};